//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Form } from 'form-backend-validation'

export default {
  auth: false,
  layout: 'front-page',
  data () {
    return {
      form: new Form({
        first_name: null,
        last_name: null,
        email: null,
        no_hp: null,
        message: null
      }),
      errors: {
        first_name: {
          error: false
        },
        last_name: {
          error: false
        },
        email: {
          error: false
        },
        no_hp: {
          error: false
        },
        message: {
          error: false
        }
      }
    }
  },
  methods: {
    checkForm () {
      if (
        this.form.first_name &&
        this.form.last_name &&
        this.form.email &&
        this.form.no_hp &&
        this.form.message
      ) {
        return true
      }
      if (!this.form.first_name) {
        this.errors.first_name.error = true
      }
      if (!this.form.last_name) {
        this.errors.last_name.error = true
      }
      if (!this.form.email) {
        this.errors.email.error = true
      }
      if (!this.form.no_hp) {
        this.errors.no_hp.error = true
      }
      if (!this.form.message) {
        this.errors.message.error = true
      }
    },
    async sendMail () {
      const formData = new FormData()
      formData.append('first_name', this.form.first_name)
      formData.append('last_name', this.form.last_name)
      formData.append('email', this.form.email)
      formData.append('no_hp', this.form.no_hp)
      formData.append('message', this.form.message)
      const result = await this.$axios
        .$post('/api/contact/sendmail', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((res) => {
          return res.data
        })
      return result
    },
    async submitForm () {
      if (this.checkForm()) {
        // console.log('ini masuk true')
        const formData = new FormData()
        formData.append('first_name', this.form.first_name)
        formData.append('last_name', this.form.last_name)
        formData.append('email', this.form.email)
        formData.append('no_hp', this.form.no_hp)
        formData.append('message', this.form.message)
        await this.$axios
          .$post('/api/contact/list', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then((res) => {
            // console.log(res)
            // this.$toasts('success', 'Berhasil Terkirim!')
          })
      } else {
        // this.$toasts('error', 'Ada Form yang kosong!')
      }
    }
  }
}
